import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CONSTS, Options } from './report-format.constants';

@Component({
  selector: 'app-report-format',
  templateUrl: './report-format.component.html',
  styleUrls: ['./report-format.component.scss'],
  standalone: false,
})
export class ReportFormatComponent {
  @Input() radioButtonValue = Options.CSV;
  @Output() emitRadioChange = new EventEmitter();

  readonly CONSTS = CONSTS;
  readonly Options = Options;

  sendRadioButtonChange($event: Event) {
    const value =
      ($event?.target as HTMLInputElement).id === Options.PDF
        ? Options.PDF
        : Options.CSV;
    this.emitRadioChange.emit(value);
  }
}
